// eslint-disable-next-line import/prefer-default-export
export const HELP_CENTER_URL = 'https://catering.ezcater.com/help';
